import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import udcLogo from '../../design-system/brand/udc-logo-web.svg';
import udcMark from '../../design-system/brand/udc-mark.svg';

/**
 * UDC logo · hairline · Parking Management — the lockup of DESIGN.md §5.
 *
 * The full logo (block, Arabic and English wordmark) only from `sm` up and
 * at 40 px tall or more, where the wordmark is still legible; on a phone the
 * block alone. Parking Management never appears larger than the UDC logo.
 *
 * The images are served from our own origin (Vite hashes them into
 * `assets/`), which is all the CSP's `img-src 'self'` allows.
 */
export function BrandLockup({
  facility,
  className = '',
  to,
}: {
  /** The facility line under the product name — omitted where it would repeat. */
  facility?: ReactNode;
  className?: string;
  /** When set the whole lockup is a link (the header: UDC logo → Live map). */
  to?: string;
}) {
  const base = `flex items-center gap-3 sm:gap-4 ${className}`;
  const content = (
    <>
      <img
        src={udcLogo}
        alt="United Development Company"
        width={80}
        height={52}
        className="hidden h-[52px] w-auto shrink-0 sm:block"
      />
      <img
        src={udcMark}
        alt="United Development Company"
        width={44}
        height={18}
        className="h-[18px] w-auto shrink-0 sm:hidden"
      />
      <span className="min-w-0 border-l border-pv-line pl-3 leading-tight sm:pl-4">
        <span className="block text-[1.0625rem] font-extrabold tracking-[-0.01em] text-pv-ink">
          Parking Management
        </span>
        {facility ? <span className="pv-eyebrow block truncate">{facility}</span> : null}
      </span>
    </>
  );
  return to ? (
    <Link to={to} title="Live map" className={base}>
      {content}
    </Link>
  ) : (
    <span className={base}>{content}</span>
  );
}
